import { supabase } from '@/integrations/supabase/client';

/**
 * Create a new Writer draft. The server creates the project and its first
 * version together, attaching the shared ready-made placeholder PDF when one
 * exists so the draft opens without waiting for a compile.
 * Returns the new project id, or null when creation failed.
 */
export async function createWriterDraft(_ownerId?: string): Promise<string | null> {
  const { data, error } = await supabase.functions.invoke<{ project_id?: string }>(
    'writer-create-draft',
    { body: {} },
  );
  if (error || !data?.project_id) {
    console.error('[Writer] Create failed', error);
    return null;
  }
  return data.project_id;
}
